export default __webpack_public_path__ + "static/media/trr-food-none.f53783bc.png";